import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "搜索", to: "/search" },
  { label: "关于我们", to: "/about" },
];

const genreLinks = ["惊悚", "恐怖", "剧情", "悬疑", "科幻", "犯罪"];

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:px-10">
        <div className="lg:col-span-2">
          <div className="mb-4 flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-film-fill text-lg"></i>
            </span>
            <span className="font-heading text-lg font-extrabold text-foreground-50">
              午夜场的电影
            </span>
          </div>
          <p className="mb-4 max-w-md text-sm leading-relaxed text-foreground-500">
            专注午夜档电影推荐与影视资讯的内容平台，覆盖惊悚、恐怖、剧情等多种类型，
            帮你找到适合当晚情绪的那一部片子。
          </p>
          <div className="flex gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-400">
              <i className="ri-mail-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-400">
              <i className="ri-weibo-line"></i>
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-400">
              <i className="ri-wechat-line"></i>
            </span>
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-foreground-100">快速导航</h4>
          <ul className="space-y-2.5">
            {quickLinks.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  className="whitespace-nowrap text-sm text-foreground-500 transition-colors hover:text-primary-400"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-heading text-sm font-bold text-foreground-100">热门类型</h4>
          <div className="flex flex-wrap gap-2">
            {genreLinks.map((genre) => (
              <Link
                key={genre}
                to={`/category?genre=${encodeURIComponent(genre)}`}
                className="rounded-full bg-background-200/70 px-3 py-1 text-xs text-foreground-400 transition-colors hover:bg-secondary-700 hover:text-secondary-100"
              >
                {genre}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-center md:flex-row md:px-6 md:text-left lg:px-10">
          <p className="text-xs text-foreground-600">
            © 2026 午夜场的电影 · 本站内容为演示数据，仅供学习与展示使用
          </p>
          <p className="text-xs text-foreground-600">
            联系邮箱：hello@midnightcinema.demo
          </p>
        </div>
      </div>
    </footer>
  );
}